
  
const initState = {
    repContact: [],
    page: 1,
    limit: 10,
    count: 0
  };
  
  const RepContactReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_REP_CONTACT':
        return {
          ...state,
          repContact: action.payload.data,
          page: action.payload.page,
          limit: action.payload.limit,
          count: action.payload.count
        };
      case 'RESET_REP_CONTACT_STATE':
        return {
          ...state,
          ...initState
        };
      default:
        return { ...state };
    }
  };
  
  export default RepContactReducer;
  